import React, { useContext, useEffect, useState } from 'react';
import './Clasament.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import StatsCard from '../popupsright/StatsCard';
import MotivationalClasament from '../rightelements/MotivationalClasament';
import GetProCard from '../rightelements/GetProCard';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';
import { useAuth } from '../../../AuthContext';
import fireIcon from '../../../imagesHome/fire.gif';
import { useNavigate } from 'react-router-dom';
import { PageNavContext } from '../FunctionalPageLoginStart';
import './reglaredimensiune.css';

const apiUrl = process.env.REACT_APP_API_URL;

const getWeeklyResetCountdown = () => {
  const now = new Date();
  const nextReset = new Date(now);
  nextReset.setHours(0, 0, 0, 0);

  // Backend-ul foloseste date_trunc('week'), deci resetul este la inceputul saptamanii (luni 00:00).
  const dayOfWeek = now.getDay();
  const daysUntilNextMonday = ((8 - dayOfWeek) % 7) || 7;
  nextReset.setDate(now.getDate() + daysUntilNextMonday);

  const diffMs = Math.max(nextReset.getTime() - now.getTime(), 0);
  const dayMs = 24 * 60 * 60 * 1000;
  const hourMs = 60 * 60 * 1000;

  const days = Math.floor(diffMs / dayMs);
  const hours = Math.floor((diffMs % dayMs) / hourMs);

  return `${days}z ${hours}h`;
};

export default function Clasament() {
  const { user: loggedUser } = useAuth();
  const pageNav = useContext(PageNavContext);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [timeUntilReset, setTimeUntilReset] = useState(getWeeklyResetCountdown);

  const loggedUserId = Number(loggedUser?.user_id);

  const currentUserEntry = users.find((entry) => {
    const entryUserId = Number(entry?.user_id);
    return Number.isFinite(loggedUserId) && loggedUserId > 0 && Number.isFinite(entryUserId) && entryUserId === loggedUserId;
  });

  const currentUserRank = currentUserEntry
    ? Number(currentUserEntry.position) || users.indexOf(currentUserEntry) + 1
    : null;
  const currentUserXp = currentUserEntry ? Number(currentUserEntry.points) || 0 : 0;
  const currentUserIndex = currentUserEntry ? users.indexOf(currentUserEntry) : -1;
  const previousUserEntry = currentUserIndex > 0 ? users[currentUserIndex - 1] : null;
  const previousUserRank = previousUserEntry
    ? Number(previousUserEntry.position) || currentUserRank - 1
    : null;
  const previousUserXp = previousUserEntry ? Number(previousUserEntry.points) || 0 : 0;
  const xpToPreviousRank = Math.max(previousUserXp - currentUserXp, 0);
  const myRankProgressPercent = currentUserRank === 1
    ? 100
    : previousUserXp > 0
      ? Math.min((currentUserXp / previousUserXp) * 100, 100)
      : 0;
  const hasZeroWeeklyXp = Boolean(currentUserEntry) && currentUserXp === 0;
  const visibleUsers = users.filter((user) => (Number(user?.points) || 0) > 0);

  useEffect(() => {
    let isMounted = true;

    const loadWeeklyLeaderboard = async () => {
      try {
        const response = await fetch(`${apiUrl}/leaderboard?type=weekly`, {
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error('Nu am putut incarca clasamentul saptamanal.');
        }

        const data = await response.json();

        if (!isMounted) {
          return;
        }

        setUsers(Array.isArray(data) ? data : []);
        setError('');
      } catch (fetchError) {
        if (!isMounted) {
          return;
        }

        console.error('Eroare leaderboard weekly:', fetchError);
        setError('Clasamentul saptamanal nu poate fi afisat momentan.');
        setUsers([]);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadWeeklyLeaderboard();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const refreshCountdown = () => {
      setTimeUntilReset(getWeeklyResetCountdown());
    };

    refreshCountdown();
    const intervalId = setInterval(refreshCountdown, 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (

    <div className="componentsmenu-container-main"> 
      <div className="componentsmenu-left-blank"></div>
      <div className="componentsmenu-container">
          <StatsCard />
          <div className="leaderboard-my-rank-hero" role="status" aria-live="polite">
            {loading ? (
              <>
                <div className="leaderboard-my-rank-head">
                  <div className="leaderboard-my-rank-title">Pozitia ta se calculeaza...</div>
                  <div className="leaderboard-my-rank-xp">-- XP</div>
                </div>
                <div className="leaderboard-my-rank-subtitle">Asteapta un moment pentru clasamentul actualizat.</div>
                <div className="leaderboard-my-rank-progress-track" aria-hidden="true">
                  <div className="leaderboard-my-rank-progress-fill" style={{ width: '35%' }} />
                </div>
              </>
            ) : hasZeroWeeklyXp ? (
              <>
                <div className="leaderboard-my-rank-head">
                  <div className="leaderboard-my-rank-title">Nu ai XP saptamanal inca</div>
                  <div className="leaderboard-my-rank-xp">0 XP</div>
                </div>
                <div className="leaderboard-my-rank-subtitle">Fa o lectie ca sa intri in clasament.</div>
                <button
                  type="button"
                  className="leaderboard-start-lessons-btn"
                  onClick={() => {
                    if (pageNav) {
                      pageNav('Invata');
                      return;
                    }

                    navigate('/functionalpagelogin');
                  }}
                >
                  Mergi la lectii
                </button>
              </>
            ) : currentUserRank ? (
              <>
                <div className="leaderboard-my-rank-head">
                  <div className="leaderboard-my-rank-title">Esti pe locul #{currentUserRank}</div>
                  <div className="leaderboard-my-rank-xp">{currentUserXp} XP</div>
                </div>
                <div className="leaderboard-my-rank-subtitle">
                  {currentUserRank === 1
                    ? 'Esti liderul saptamanii'
                    : `Mai ai nevoie de ${xpToPreviousRank} XP ca sa ajungi pe locul #${previousUserRank}`}
                </div>
                <div className="leaderboard-my-rank-progress-track" aria-hidden="true">
                  <div
                    className="leaderboard-my-rank-progress-fill"
                    style={{ width: `${myRankProgressPercent}%` }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="leaderboard-my-rank-head">
                  <div className="leaderboard-my-rank-title">🔥 Pozitia ta nu este in clasament</div>
                  <div className="leaderboard-my-rank-xp">0 XP</div>
                </div>
                <div className="leaderboard-my-rank-subtitle">Continua sa castigi XP pentru a urca in top.</div>
                <div className="leaderboard-my-rank-progress-track" aria-hidden="true">
                  <div className="leaderboard-my-rank-progress-fill" style={{ width: '0%' }} />
                </div>
              </>
            )}
          </div>
        
        <div className="leaderboard-list">
          <div className="leaderboard-title-row">
            <div className="certificate-title-custom">Clasament saptamanal</div>
            <div className="leaderboard-reset-time">
              <img src={fireIcon} alt="fire" className="leaderboard-reset-fire" />
              Se termina in {timeUntilReset}
            </div>
          </div>
        
          <div className="leaderboard-scroll-area">
            {loading && <div className="leaderboard-message leaderboard-feedback">Se incarca clasamentul saptamanal...</div>}
            {!loading && error && <div className="leaderboard-message leaderboard-feedback">{error}</div>}
            {!loading && !error && visibleUsers.length === 0 && (
              <div className="leaderboard-message leaderboard-feedback">Nu exista inca utilizatori cu XP saptamanal.</div>
            )}
            {!loading && !error && visibleUsers.map((user, index) => {
              const rank = Number(user.position) || index + 1;
              const isTop3 = rank <= 3;
              const entryUserId = Number(user?.user_id);
              const isLoggedUser =
                Number.isFinite(loggedUserId) && loggedUserId > 0 && Number.isFinite(entryUserId) && entryUserId === loggedUserId;

              return (
                <React.Fragment key={user.user_id || `${user.username}-${index}`}>
                  {index === 3 && <div className="leaderboard-cutoff" aria-hidden="true" />}
                  <div
                    className={`leaderboard-user current ${isTop3 ? `top-rank top-rank-${rank}` : 'other-rank'} ${isLoggedUser ? 'logged-user-row' : ''}`}
                    style={{ marginBottom: index === users.length - 1 ? 0 : undefined }}
                  >
                    <div className="leaderboard-rank-wrap">
                      <span className={`leaderboard-rank ${isTop3 ? 'top-rank-number' : ''}`}>#{rank}</span>
                      
                    </div>
                    <div className="leaderboard-avatar current">
                      {user.profile_picture ? (
                        <img
                          src={user.profile_picture}
                          alt={user.username || 'Utilizator'}
                          className="leaderboard-avatar-image"
                        />
                      ) : (
                        <FontAwesomeIcon icon={faUser} className="leaderboard-usericon" />
                      )}
                    </div>
                    <div className="leaderboard-name current">
                      {user.username || 'Utilizator'}
                    </div>
                    <div className="leaderboard-xp current">{user.points || 0} XP</div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
      <div className="right-elements-componentsmenu">
        <GetProCard />
       <MotivationalClasament />
          <FooterElements />
      <SocialElements />
      </div>
    </div>
  );
}
